import startsWith from 'underscore.string/startsWith';

export function calculatePercentDifference(currentVal, previousVal) {
    if (currentVal.amount) {
        return (currentVal.amount.value - previousVal.amount.value) / previousVal.amount.value;
    }

    return (currentVal.count - previousVal.count) / previousVal.count;
}

export function convertValueToString(value) {
    if (value.amount) {
        return value.amount.prefix + value.amount.formatted + value.amount.suffix;
    }

    return value.count === 0 ? 'No leads' : value.count;
}

// TODO (@ianvs): Add docblock
export function formatPeriod(periodQueryString, relativePeriod) {
    if (!periodQueryString) return;

    let formattedPeriod;
    const isCurrent = relativePeriod === 'current';
    const isPrevious = relativePeriod === 'previous';
    // "Within"
    if (startsWith(periodQueryString, '-')) {
        const period = getDurationString(periodQueryString.charAt(1));
        const qty = periodQueryString.slice(2);

        if (qty === '1') {
            formattedPeriod = `${qty} ${period}`;
        } else {
            formattedPeriod = `${qty} ${period}s`;
        }

        if (isCurrent) {
            formattedPeriod = `past ${formattedPeriod}`;
        } else if (isPrevious) {
            formattedPeriod = `previous ${formattedPeriod}`;
        }
    } else {
        formattedPeriod = getDurationString(periodQueryString);
        const previousPrefix = periodQueryString.length === 1 ? 'last ' : 'this time last ';
        if (isCurrent) {
            if (formattedPeriod === 'day') {
                formattedPeriod = 'today';
            } else {
                formattedPeriod = `this ${formattedPeriod}`;
            }
        } else if (isPrevious) {
            if (formattedPeriod === 'day') {
                formattedPeriod = 'yesterday';
            } else {
                formattedPeriod = previousPrefix + formattedPeriod;
            }
        } else if (periodQueryString.slice(1) === 'td') {
            formattedPeriod = `${formattedPeriod}-to-date`;
        }
    }

    return formattedPeriod;
}

/*
Shamelessly copied from nutshell-core/deserialize-url-param.js
But, this one returns singular period strings.
 */
function getDurationString(chr) {
    switch (chr) {
        case 'M':
            return 'minute';
        case 'h':
            return 'hour';
        case 'd':
            return 'day';
        case 'w':
        case 'wtd':
            return 'week';
        case 'm':
        case 'mtd':
            return 'month';
        case 'q':
        case 'qtd':
            return 'quarter';
        case 'y':
        case 'ytd':
            return 'year';
    }
}
